<template>
  <div class="card mgb-20px has-background-background disableBoxShadow border-color-select"
       :class="isNotRegie ? 'min-width-1600px' : 'min-width-1250px'">
    <div class="card-content min-height-81px pd-11px"
         :class="{'table-error' : checkErrorDate}">
      <div class="columns is-multiline">
        <div class="column is-narrow mgt-1em">
          <div class="columns">
            <div class="column is-narrow">
              <qd-checkbox v-model="echeancier.select"></qd-checkbox>
              <a @click="echeancier.openEcheancierLignes = !echeancier.openEcheancierLignes"
                 :class="{'pointer-events-none' : isAuto
                 && !haveOneEcheancierLigneWithFacturation }">
                <b-icon :icon="echeancier.openEcheancierLignes ? 'chevron-down' : 'chevron-right'"
                        class="mgl-10px"
                        :class="{'disabled' : isAuto
                        && !haveOneEcheancierLigneWithFacturation }">
                </b-icon>
              </a>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="columns">
            <div class="column is-6">
              <div class="columns">
                <div class="column mgt-1em"
                     :class="isNotRegie ? 'is-6' : 'is-9'">
                  <div class="columns max-width-400px">
                    <div class="column is-narrow pdr-0 pdl-0" v-if="isFusion">
                      <b-icon icon="circle-multiple-outline"
                              type="is-primary"
                              custom-size="mdi-16px">
                      </b-icon>
                    </div>
                    <div class="column" :class="{ 'is-11': isFusion, 'is-12': !isFusion}">
                      <div v-for="(libelles, index) in getObjectLibelle" :key="index"
                           :class="{ 'mgt-5px' : index !== 0}">
                        <p class="has-text-weight-bold ellipsis">
                          {{libelles.libelleProduit }}
                        </p>
                        <p class="ellipsis is-size-7">{{ libelles.libellePatri }}</p>
                        <p v-if="libelles.dateDebut" class="is-size-7">
                          {{ getDate(libelles.dateDebut) }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="column is-3 ellipsis mgt-1em"
                     v-if="isNotRegie">
                  <span :class="getFournisseur(echeancier.referenceEcheancier)
                  === $t('echeancierFacturation.tabs.valDiff') ? 'has-text-danger': ''">
                    {{ getFournisseur(echeancier.referenceEcheancier) }}
                  </span>
                </div>
                <div class="column is-2 ellipsis right mgt-1em">
                  {{ getMontantEcheancier | formatDevise }}
                </div>
              </div>
            </div>
            <div class="column is-6">
              <div class="columns">
                <div class="column is-4">
                  <button class="button is-fullwidth"
                          :class="isAuto ? 'is-primary'
                          : 'is-annuler has-text-link btn-modal-annuler'"
                          v-if="!haveOneEcheancierLigneWithFacturation && getMontantEcheancier > 0"
                          @click="$emit('generationEcheancierManuel',
              echeancier.referenceEcheancier, getMontantEcheancier)">
                    {{ $t(isAuto ? 'echeancierFacturation.actions.create'
                    : 'echeancierFacturation.actions.regenerate' )}}
                  </button>
                </div>
                <div class="column is-4">
                  <div class="columns">
                    <div class="column is-narrow">
                      <b-datepicker show-week-number
                                    position="is-bottom-left"
                                    class="width-170px"
                                    v-if="isAuto && !haveOneEcheancierLigneWithFacturation"
                                    @input="changeDatesEcheancier"
                                    icon="calendar-today"
                                    :editable="true"
                                    v-model="echeancier.dateDebut"
                                    :nearby-selectable-month-days="true">
                      </b-datepicker>
                    </div>
                  </div>
                </div>
                <div class="column is-2 ellipsis mgt-1em"
                     v-if="isNotRegie">
                    <span :class="getAFacturer(echeancier.referenceEcheancier)
                    === $t('echeancierFacturation.tabs.valDiff')? 'has-text-danger' : ''">
                      {{ getAFacturer(echeancier.referenceEcheancier) }}
                    </span>
                </div>
                <div class="column is-1 mgt-1em">
                  <b-tooltip v-if="isAuto && echeancier.echeancierLignes[0]
                      && echeancier.echeancierLignes[0].commentaireFacturation"
                             position="is-left"
                             type="is-primary">
                    <b-icon icon="information" type="is-primary">
                    </b-icon>
                    <template v-slot:content>
                      <p class="ellipsis max-width-715">
                        {{ echeancier.echeancierLignes[0].commentaireFacturation }}
                      </p>
                    </template>
                  </b-tooltip>
                </div>
                <div class="column right mgt-1em">
                  <b-dropdown position="is-bottom-left" class="has-text-left"
                              aria-role="list">
                    <a slot="trigger">
                      <b-icon
                        custom-class="has-text-icon-more"
                        icon="dots-vertical">
                      </b-icon>
                    </a>
                    <b-dropdown-item aria-role="listitem"
                                     v-if="!isAuto || haveOneEcheancierLigneWithFacturation"
                                     @click="addLigneEcheancier()">
                      <div class="media">
                        <div class="media-content">
                          <p class="is-default font-dropdown">
                            {{ $t('echeancierFacturation.actions.addEcheance')}}
                          </p>
                        </div>
                      </div>
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"
                                     v-if="isFusion && !haveOneEcheancierLigneWithFacturation"
                                     @click="prepareDefusion()">
                      <div class="media">
                        <div class="media-content">
                          <p class="is-default font-dropdown">
                            {{ $t('echeancierFacturation.actions.defusion')}}
                          </p>
                        </div>
                      </div>
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"
                                     v-if="!isAuto && !haveOneEcheancierLigneWithFacturation"
                                     @click="prepareSuppresion">
                      <div class="media">
                        <div class="media-content">
                          <p class="is-default font-dropdown">
                            {{ $t('echeancierFacturation.actions.delete')}}
                          </p>
                        </div>
                      </div>
                    </b-dropdown-item>
                    <b-dropdown-item aria-role="listitem"
                                     v-if="getLigneWithoutFacturation.length > 0"
                                     @click="openPopUpEditCommentaire = true">
                      <div class="media">
                        <div class="media-content">
                          <p class="is-default font-dropdown">
                            {{ $t('echeancierFacturation.actions.gestionCommentaire')}}
                          </p>
                        </div>
                      </div>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-12" v-if="echeancier.openEcheancierLignes">
          <echeancier-lignes
            :showErrorDate="showErrorDate"
            :montantEcheances="getMontantEcheancier"
            :echeancier-lignes="echeancier.echeancierLignes"
            :montantHtCommande="dcf.montantHt"
            :payeurs="payeurs"
            @prepareEcheancierSuppression="prepareSuppresion">
          </echeancier-lignes>
        </div>
      </div>
    </div>
    <b-modal v-model="popUpPrevention"
             has-modal-card
             class="modal">
      <pop-up-prevention
        :messHeader="titlePrevention"
        :messFooter="subTitlePrevention"
        :cancel="$t('echeancierFacturation.actions.cancel')"
        :validate="titleBoutonValidationPrevention"
        @no="popUpPrevention = false"
        @yes="makeDefusionSuppresion"
      />
    </b-modal>
    <b-modal v-model="openPopUpEditCommentaire"
             has-modal-card
             class="modal">
      <pop-up-edit-commentaire-facturation :echeancier-lignes="getLigneWithoutFacturation"
                                           @updateCommentaire="updateCommentaireFacturation">
      </pop-up-edit-commentaire-facturation>
    </b-modal>
  </div>
</template>

<script>

import getLibellesEcheancier from '@/services/commande/echeancierFacturation/getLibellesEcheancier';
import getLignesCommandesWithReferenceEcheancier
  from '@/services/commande/echeancierFacturation/getLignesCommandesWithReferenceEcheancier';
import formatDate from '@/services/general/formatDate';
import popUpPrevention from '@/components/general/popUpPrevention';
import defusionEcheancier from '@/services/commande/echeancierFacturation/defusionEcheancier';
import messageSucces from '@/services/general/messageSucces';
import echeancierLignes from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/echeancierLignes';
import { checkUnconsecutiveDateEcheancier } from '@/services/commande/echeancierFacturation/checkUnconsecutiveDateEcheanciers';
import { genererLigneEcheancier } from '@/services/commande/echeancierFacturation/genererLigneEcheancier';
import { REGIE } from '@/configuration/societe/societe';
import popUpEditCommentaireFacturation
  from '@/components/devisCommandes/editionDevisCommande/echeancierFacturation/p_commentaireFacturation';
import calculArrondi from '@/services/calcul/calculArrondi';

export default {
  name: 'DevisCommandesEditEchanecierFacturation',
  props: {
    echeancier: {
      type: Object,
      required: true,
    },
    lignesCommande: {
      type: Array,
      required: true,
    },
    dcf: {
      type: Object,
      required: true,
    },
    payeurs: {
      type: Array,
      required: true,
    },
    showErrorDate: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      popUpPrevention: false,
      titlePrevention: null,
      subTitlePrevention: null,
      titleBoutonValidationPrevention: null,
      action: null,
      openPopUpEditCommentaire: false,
    };
  },
  components: {
    popUpPrevention,
    echeancierLignes,
    popUpEditCommentaireFacturation,
  },
  computed: {
    isNotRegie() {
      return this.dcf.role !== REGIE;
    },
    getObjectLibelle() {
      return getLibellesEcheancier(this.echeancier.referenceEcheancier, this.lignesCommande);
    },
    getMontantEcheancier() {
      const lignes = getLignesCommandesWithReferenceEcheancier(
        this.lignesCommande, this.echeancier.referenceEcheancier,
      );
      const total = lignes.map((ligne) => { return ligne.totalHtAvecLigneRemise; })
        .reduce((montantTotal, montant) => montantTotal + montant);
      return calculArrondi(total);
    },
    isAuto() {
      return (this.echeancier.quantitePeriodicite === 0);
    },
    getLigneWithoutFacturation() {
      return this.echeancier.echeancierLignes.filter((ligne) => {
        return !ligne.facturationFaite;
      });
    },
    haveOneEcheancierLigneWithFacturation() {
      return this.echeancier.echeancierLignes.some((ligne) => { return ligne.facturationFaite; });
    },
    isFusion() {
      return (getLignesCommandesWithReferenceEcheancier(
        this.lignesCommande, this.echeancier.referenceEcheancier,
      ).length > 1);
    },
    checkErrorDate() {
      if (!this.showErrorDate) return false;
      return checkUnconsecutiveDateEcheancier([this.echeancier], this.payeurs);
    },
  },
  methods: {
    updateCommentaireFacturation(newCommentaire) {
      messageSucces(this.$i18n.t('echeancierFacturation.messages.success.editCommentaire'));
      this.openPopUpEditCommentaire = false;
      if (this.echeancier.echeancierLignes.length === 0) return;
      this.echeancier.echeancierLignes.forEach((ligne) => {
        if (!ligne.facturationFaite) ligne.commentaireFacturation = newCommentaire;
      });
    },
    getFournisseur(referenceEcheancier) {
      const lignes = getLignesCommandesWithReferenceEcheancier(
        this.lignesCommande, referenceEcheancier,
      );
      if (!lignes.every((ligne) => {
        return ligne.fournisseurId === lignes[0].fournisseurId;
      })) return this.$i18n.t('echeancierFacturation.tabs.valDiff');
      return lignes[0].fournisseur ? lignes[0].fournisseur.nomCommercial : '';
    },
    getAFacturer(referenceEcheancier) {
      const lignes = getLignesCommandesWithReferenceEcheancier(
        this.lignesCommande, referenceEcheancier,
      );
      const aFacturerBase = lignes[0].aFacturer;
      if (!lignes.every((ligne) => {
        return ligne.aFacturer === aFacturerBase;
      })) return this.$i18n.t('echeancierFacturation.tabs.valDiff');
      return aFacturerBase ? this.$i18n.t('general.oui') : this.$i18n.t('general.non');
    },
    addLigneEcheancier() {
      const ligne = genererLigneEcheancier();
      if (this.payeurs.length === 1) ligne.tiersId = this.payeurs[0].tiersId;
      if (this.echeancier.quantitePeriodicite === 0) this.echeancier.quantitePeriodicite = 1;
      this.echeancier.echeancierLignes.push(ligne);
    },
    prepareSuppresion() {
      this.titlePrevention = this.$i18n.t('echeancierFacturation.messages.prevention.suppression.title');
      this.subTitlePrevention = this.$i18n.t('echeancierFacturation.messages.prevention.suppression.subTitle');
      this.titleBoutonValidationPrevention = this.$i18n.t('echeancierFacturation.actions.delete');
      this.popUpPrevention = true;
      this.action = 'SUPPRESION';
    },
    prepareDefusion() {
      this.titlePrevention = this.$i18n.t('echeancierFacturation.messages.prevention.defusion.title');
      this.subTitlePrevention = this.$i18n.t('echeancierFacturation.messages.prevention.defusion.subTitle');
      this.titleBoutonValidationPrevention = this.$i18n.t('echeancierFacturation.actions.defusion');
      this.popUpPrevention = true;
      this.action = 'DEFUSION';
    },
    makeDefusionSuppresion() {
      this.titlePrevention = null;
      this.subTitlePrevention = null;
      this.titleBoutonValidationPrevention = null;
      this.popUpPrevention = false;
      defusionEcheancier([this.echeancier.referenceEcheancier], this.dcf);
      messageSucces(this.$i18n.t(this.action === 'DEFUSION'
        ? 'echeancierFacturation.messages.success.defusion'
        : 'echeancierFacturation.messages.success.suppresion'));
    },
    getDate(date) {
      return this.$i18n.t('echeancierFacturation.tabs.datePatri', { date: formatDate(date) });
    },
    changeDatesEcheancier(newDate) {
      this.echeancier.dateFin = newDate;
      this.echeancier.dateFinPremiereEcheance = newDate;
    },
  },
  mounted() {
    if (!this.isAuto || this.haveOneEcheancierLigneWithFacturation) {
      this.echeancier.openEcheancierLignes = true;
    }
  },
};
</script>
